import { Box, Flex, Stack } from '@chakra-ui/react';
import LoadingLayout from 'components/Loading';
import useMobile from 'hooks/useMobile';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

import { Navbar, NavLink } from '../components/NavBar';
import AmatriumLogo from '../components/NavBar/AmatriumLogo';
import { privateUserRouters } from '../router';

const PrivateUserLayout = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { isMobile } = useMobile();

  return (
    <Stack
      minH='100vh'
      px={{ base: '1.25rem', md: '1.75rem', lg: '3rem', '2xl': '4.5rem' }}
      pt={{ base: ' 1rem', md: '1.5rem', lg: '2.5rem', '2xl': '3rem' }}
      bg='bg_main_container'
    >
      <Navbar>
        <Navbar.Brand>
          <Link to='/'>
            <Flex
              align='center'
              w={{ base: '6rem', md: '9rem', lg: '11rem', '2xl': '14rem' }}
              h={{
                base: '1.92rem',
                md: '1.92rem',
                lg: '2rem',
                '2xl': '2.5rem',
              }}
            >
              <AmatriumLogo width='100%' height='100%' />
            </Flex>
          </Link>
        </Navbar.Brand>

        <Navbar.Links>
          {privateUserRouters.map((route) => (
            <React.Fragment key={route.key}>
              {(!isMobile || route.isMobile) && (
                <NavLink
                  as={Link}
                  to={route.path}
                  key={route.key}
                  isActive={location.pathname === route.path}
                >
                  {t(route.label)}
                </NavLink>
              )}
            </React.Fragment>
          ))}
        </Navbar.Links>
      </Navbar>
      {/* <AmatriumSkeleton /> */}
      <Box
        pt={{
          base: '0.5rem',
          md: '0.75rem',
          lg: '1.5rem',
        }}
      >
        <LoadingLayout isLoading={props.isLoading}>{props.children}</LoadingLayout>
      </Box>
    </Stack>
  );
};

export default PrivateUserLayout;
